module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gmap-map', {
    ref: "map",
    staticClass: "map-container",
    attrs: {
      "center": {
        lat: _vm.currentLocation.lat,
        lng: _vm.currentLocation.lng
      },
      "zoom": 12
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.currentLocation.lat,
        lng: _vm.currentLocation.lng
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfcc93f6","hasScoped":false}!./src/app/components/map/map.html
// module id = 3117
// module chunks = 1